<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Sales List</span>
    </div>
    <!-- Table Start -->
    <v-row justify="start" align="start">
      <v-chip class="mx-2" filter :input-value="chipFilter == 'all'" @click="setChipFilter('all')">
        All
      </v-chip>
      <v-chip
        class="mx-2"
        filter
        :input-value="chipFilter == 'receivable'"
        @click="setChipFilter('receivable')"
      >
        Receivable
      </v-chip>
      <v-chip
        class="mx-2"
        filter
        :input-value="chipFilter == 'fullypaid'"
        @click="setChipFilter('fullypaid')"
      >
        Fully Paid
      </v-chip>
    </v-row>
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by customer name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Customer</th>
            <th class="text-left">Customer Contact Numbers</th>
            <th class="text-left">Total</th>
            <th class="text-left">Discount</th>
            <th class="text-left">Net Amount</th>
            <th class="text-left">Amount Receivable</th>
            <th class="text-left">Sale Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sales" :key="item.id" @click="showSale(item.id)">
            <td class="text-left">{{ item.customer.name }}</td>
            <td class="text-left">{{ item.customer.contact_numbers }}</td>
            <td class="text-left">{{ (item.amount || '').toLocaleString() }}</td>
            <td class="text-left">{{ (item.discount || '').toLocaleString() }}</td>
            <td class="text-left">{{ (item.net_amount || '').toLocaleString() }}</td>
            <td class="text-left">{{ (item.amount_receivable || '').toLocaleString() }}</td>
            <td class="text-left">{{ item.created_at }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="7" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <saleShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import saleShow from './SaleShow';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      chipFilter: 'all',
      paginationcount: '10'
    };
  },
  components: {
    saleShow
  },
  props: {
    create: false,
    show: false,
    edit: false
  },
  watch: {
    page(val) {
      this['Sale/fetchSales']({
        page: val,
        filter: this.chipFilter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['Sale/getSale']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      sales: state => state.Sale.sales.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.Sale.sales.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.Sale.sales;
      }
    })
  },
  mounted() {
    this['Sale/fetchSales']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['Sale/fetchSales', 'Sale/getSale']),
    setChipFilter(chip) {
      this.chipFilter = chip;
      this.filterList();
    },
    showSale(id) {
      this.$router.push(`/sale/${id}`);
    },
    filterList() {
      // if (this.page !== 1) this.page = 1;
      // else this['Sale/fetchSales']({ page: this.page, filter: this.filter });
      this.page = 1;
      this['Sale/fetchSales']({
        page: this.page,
        customer_name: this.filter,
        filter: this.chipFilter,
        paginationcount: this.paginationcount
      });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else
        this['Sale/fetchSales']({
          page: this.page,
          filter: this.chipFilter,
          paginationcount: this.paginationcount
        });
    }
  }
};
</script>
